import React, { useEffect, useRef, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';

const StickyActionBar = ({ children }) => {
  const divRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const div = divRef.current;
    if (!div) return undefined;

    // The div sits at the bar's natural position: once it leaves the viewport, the bar is sticky
    const observer = new IntersectionObserver(([entry]) => setIsSticky(!entry.isIntersecting));
    observer.observe(div);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Stack
        direction="row"
        sx={(theme) => ({
          position: 'sticky',
          bottom: 0,
          zIndex: 4, // above the sticky "Zone" column cells (zIndex 3)
          gap: 1,
          justifyContent: 'end',
          mx: -2,
          px: 2,
          py: 1,
          mb: -2,
          backgroundColor: theme.palette.background.paper,
          boxShadow: isSticky ? `0 -4px 8px -4px ${alpha(theme.colorTokens.shadow, 0.15)}` : 'none',
          transition: theme.transitions.create('box-shadow', { duration: theme.transitions.duration.shorter }),
        })}
      >
        {children}
      </Stack>
      <Box ref={divRef} sx={{ height: '1px' }} />
    </>
  );
};

export default StickyActionBar;
